import React from 'react';
import {
    HeadingText40,
    BodyTextMedium,
    BodyTextXSmall,
    pxToRem,
} from '@modernhealth/vital-components';
import styled from '@emotion/styled';

const ContentWrapper = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
`;

const Content = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: ${pxToRem(400)};
`;

const ButtonGroup = styled.div`
    margin: ${pxToRem(0, 15)};
`;

const StyledImg = styled.img`
    user-select: none;
`;

interface Props {
    imgSrc: string;
    title: string;
    description: string;
    buttons: React.ReactNode;
    footnote: React.ReactNode;
}

export const ErrorView: React.FC<Props> = ({ imgSrc, title, description, buttons, footnote }) => {
    return (
        <ContentWrapper>
            <Content>
                <StyledImg src={imgSrc} alt="" />
                <HeadingText40 centered marginTop={8} marginBottom={8}>
                    {title}
                </HeadingText40>
                <BodyTextMedium centered marginBottom={30}>
                    {description}
                </BodyTextMedium>
                <ButtonGroup>{buttons}</ButtonGroup>
                <BodyTextXSmall marginTop={20}>{footnote}</BodyTextXSmall>
            </Content>
        </ContentWrapper>
    );
};
